
<t4-header icon="glyphicon-stats">

  <button [disabled]="!action || !(tblAssets.selectedRows?.length > 0)" (click)="CancelSubscriptions()" mat-button type="button">
    <mat-icon>cancel</mat-icon>{{ 'T4.Service.ServiceGuyDialog.lblCancelSubscription' | translate : 'Cancel contract'}}
  </button>

  <button [disabled]="!action || !(tblAssets.selectedRows?.length > 0)" (click)="TransferAssets()" mat-button type="button">
    <mat-icon>trending_flat</mat-icon>{{ 'T4.Service.ServiceGuyDialog.lblInventoryAssetTransfer' | translate : 'Transfer'}}
  </button>

  <button [disabled]="!action || !(tblAssets.selectedRows?.length > 0)" (click)="ScrapAssets()" mat-button type="button">
    <mat-icon>delete_forever</mat-icon>{{ 'T4.Service.ServiceGuyDialog.lblInventoryAssetScrap' | translate : 'Scrap'}}
  </button>

  <button (click)="ImportTracker()" mat-button type="button">
    <mat-icon>arrow_upward</mat-icon>{{ 'T4.Service.ServiceGuyDialog.lblImportTracker' | translate : 'Import tracker'}}
  </button>
</t4-header>

@if(showImportTracker) {
<t4-container [IsLoading]="loading">
  <p>{{ 'T4.Service.ServiceGuyDialog.lblImportTrackerInfo' | translate:'Import an excel file with tracker information to continue.'}}</p>
  <p>{{ 'T4.Service.ServiceGuyDialog.lblImportTrackerInfo1' | translate:'Please download the template and add the tracker information to the respective fields.'}} <a href="https://thuleturbo.blob.core.windows.net/documents/ImportTrackerTemplate.xlsx" download target="_blank">{{ 'T4.Service.ServiceGuyDialog.lblImportTrackerInfoDownloadtemplate' | translate:'Click here to download the template'}}</a></p>
  <p>{{ 'T4.Service.ServiceGuyDialog.lblImportTrackerInfo3' | translate:'Please note that the fields Model, SerialNo, IMEI and IccId are mandatory fields. The trackers without these information will not be imported to T4.'}}</p>
  <button mat-stroked-button style="border-radius:15px; margin-top:10px;" (click)="beginUpload()">{{ 'T4.Service.ServiceGuyDialog.BtnSelectFile' | translate:'Select file'}}</button>
  <input #txtFile type="file" style="visibility:hidden" (change)="upload($event.target.files)" />
</t4-container>
}

<t4-container>
  <div class="topMenu">
    <div style="flex-grow: 1;">
      <!-- This div will take up remaining space -->
      <mat-checkbox style="margin-left:2px;" [ngModel]="onContract" (ngModelChange)="onContract = $event; filterAssets();">Only on contract</mat-checkbox><br />
    </div>
    <div style="margin-left: auto;">
      <span class="color-square active-contract" style="border-radius: 5px;"></span>: Active Contract
    </div>
  </div>

  <t4-data-table #tblAssets [allowFilter]="true" style="background-color:white" [rawData]="CopyAsset" [allowExcel]="true" headline="{{'T4.Service.InventoryStaus.Headline' | translate : 'Inventory status' }}" matSort matSortActive="ConfirmedDt" matSortDirection="desc" [allowMultiSelect]="true" [autoGenerateColumns]="false" [filterFields]="['SerialId','Mac', 'PositionTime', 'CurrentPosition']">

    <ng-container matColumnDef="AssetCondition">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:55px;"></mat-header-cell>
      <mat-cell [ngClass]="{'active-contract': hasActiveContract(row)}" *matCellDef="let row" (click)="assetInfomation(row)" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:55px; margin-left:5px;"><mat-icon style="transform:rotate(90deg)">search</mat-icon></mat-cell>
    </ng-container>

    <ng-container id="SerialId" name="SerialId" matColumnDef="SerialId">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:250px;">{{'T4.Service.Asset.SerialId' |translate : 'SerialId' }}</mat-header-cell>
      <mat-cell [ngClass]="{'active-contract': hasActiveContract(row)}" *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:250px;">{{ row.SerialId }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="CurrentPosition">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:350px;">{{'T4.Service.Asset.currentLocation' |translate : 'Current location' }}</mat-header-cell>
      <mat-cell [ngClass]="{'active-contract': hasActiveContract(row)}" *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:350px;">{{row.CurrentPosition}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="GetThere">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;">{{'T4.Service.Asset.LocationDate' |translate : 'Located Date' }}</mat-header-cell>
      <mat-cell [ngClass]="{'active-contract': hasActiveContract(row)}" *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;">{{row.LastUpdated | date : 'yyyy-MM-dd HH:mm'}}</mat-cell>
    </ng-container>

  </t4-data-table>
</t4-container>
